export const statsCounter = () => {
    const snippets = document.querySelectorAll(".stats-tiles");

    if (!snippets) {
        return;
    }

    snippets.forEach((snippet) => {
        window.addEventListener("scroll", () => {
            startCount(snippet);
        });
    });
};

function counter(snippet) {
    const stats = snippet.querySelectorAll(".stats-tiles__tile");

    stats.forEach((stat) => {
        const statNumber: HTMLHeadingElement = stat.querySelector(
            ".stats-tiles__stat"
        );

        animate(statNumber, 5000);
    });
}

function animate(stat, speed) {
    const countUpTo = +stat.dataset.count;
    const currentNumber = +stat.innerText.replace(/,/g, "");
    const animationspeed = speed;

    const time = countUpTo / animationspeed;
    if (currentNumber < countUpTo) {
        const countuptext = Math.ceil(currentNumber + time);
        stat.innerText = countuptext.toLocaleString("en-GB");

        setTimeout(() => {
            animate(stat, speed);
        }, 1);
    } else {
        stat.innerText = countUpTo.toLocaleString("en-GB");
    }
}

function startCount(snippet) {
    // define an observer instance
    var observer = new IntersectionObserver(onIntersection, {
        root: null, // default is the viewport
        threshold: 0.5, // percentage of target's visible area. Triggers "onIntersection"
    });

    // callback is called on intersection change
    function onIntersection(entries, opts) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                counter(snippet);
            }
        });
    }

    // Use the observer to observe an element
    observer.observe(snippet);

    // To stop observing:
    // observer.unobserve(entry.target)
}
